import { apiDelete } from "../baseApi";

export const deleteById = async (id) => {
  try {
    const response = await apiDelete("_tag", id, {});
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
